import { GripVertical } from "lucide-react";
import { DndContext, PointerSensor, TouchSensor, KeyboardSensor, closestCenter, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, arrayMove, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Switch } from "../../components/ui/switch";
import { useLang } from "../../lib/i18n";

const Row = ({ f, shown, onToggle }) => {
  const { t, pick } = useLang();
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: f.key });
  return (
    <li ref={setNodeRef} style={{ transform: CSS.Transform.toString(transform), transition }} data-testid={`profile-field-${f.key}`}
      className={`flex items-center gap-2 rounded-xl border border-slate-200/80 bg-white px-2 py-1.5 ${isDragging ? "relative z-10 shadow-lg" : ""}`}>
      <button type="button" {...attributes} {...listeners} title={t("Drag to reorder")} data-testid={`profile-field-drag-${f.key}`}
        className="flex h-8 w-8 cursor-grab touch-none items-center justify-center rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-900 active:cursor-grabbing">
        <GripVertical className="h-4 w-4" />
      </button>
      <span className={`me-auto text-sm font-semibold ${shown ? "text-slate-900" : "text-slate-400 line-through"}`}>{pick(f.label_en, f.label_ar)}</span>
      <Switch checked={shown} onCheckedChange={(v) => onToggle(f.key, v)} data-testid={`profile-field-show-${f.key}`} />
    </li>
  );
};

export const ProfileFieldOrder = ({ list, hidden, onOrder, onToggle }) => {
  const sensors = useSensors(useSensor(PointerSensor), useSensor(TouchSensor, { activationConstraint: { delay: 150, tolerance: 5 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }));
  const onDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;
    const keys = list.map((f) => f.key);
    onOrder(arrayMove(keys, keys.indexOf(active.id), keys.indexOf(over.id)));
  };
  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
      <SortableContext items={list.map((f) => f.key)} strategy={verticalListSortingStrategy}>
        <ul className="space-y-1.5" data-testid="profile-field-list">
          {list.map((f) => <Row key={f.key} f={f} shown={!hidden.includes(f.key)} onToggle={onToggle} />)}
        </ul>
      </SortableContext>
    </DndContext>
  );
};
